export default __webpack_public_path__ + "basketball-ball-variant.png";